"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
const bcfParser_1 = require("../utils/bcfParser");
const dateFormatter_1 = require("../utils/dateFormatter");
const relativeTime_1 = require("../utils/relativeTime");
class BCFViewer {
    constructor(container) {
        this.currentData = null;
        this.container = container;
    }
    loadBCFFile(file) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                this.showLoading();
                this.currentData = yield (0, bcfParser_1.parseBCFFile)(file);
                this.render();
            }
            catch (error) {
                console.error('Error loading BCF file:', error);
                this.showError('Failed to load BCF file');
            }
        });
    }
    showLoading() {
        this.container.innerHTML = '<div class="loading">Loading BCF file...</div>';
    }
    showError(message) {
        this.container.innerHTML = `<div class="error">${message}</div>`;
    }
    render() {
        if (!this.currentData)
            return;
        this.container.innerHTML = '';
        const headerDiv = document.createElement('div');
        headerDiv.className = 'bcf-header';
        headerDiv.innerHTML = `
	  <h2>BCF File Contents</h2>
	  <p>Version: ${this.currentData.version.VersionId}</p>
	  ${this.currentData.project ? `<p>Project: ${this.currentData.project.Name || 'Unnamed'}</p>` : ''}
	`;
        this.container.appendChild(headerDiv);
        this.currentData.topics.forEach((topicData, index) => {
            const topicElement = this.renderTopicElement(topicData, index);
            this.container.appendChild(topicElement);
        });
    }
    renderTopicElement(topic, index) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l;
        const markup = topic.markup;
        console.log(`Rendering topic ${index} with ${topic.images.length} images`);
        const topicDiv = document.createElement('div');
        topicDiv.className = 'topic';
        topicDiv.setAttribute('data-topic-index', index.toString());
        const title = document.createElement('h3');
        title.textContent = `Topic: ${((_a = markup.Topic) === null || _a === void 0 ? void 0 : _a.Title) || 'Untitled'}`;
        topicDiv.appendChild(title);
        const detailsDiv = document.createElement('div');
        detailsDiv.className = 'topic-details';
        const table = document.createElement('table');
        table.className = 'topic-details-table';
        // Create table rows for each detail
        const details = [
            { label: 'Status', value: ((_b = markup.Topic) === null || _b === void 0 ? void 0 : _b.TopicStatus) || 'Unknown', isDate: false, originalDate: null },
            { label: 'Priority', value: ((_c = markup.Topic) === null || _c === void 0 ? void 0 : _c.Priority) || 'Unknown', isDate: false, originalDate: null },
            { label: 'Creation Date', value: ((_d = markup.Topic) === null || _d === void 0 ? void 0 : _d.CreationDate) ? (0, dateFormatter_1.formatDateTime)(markup.Topic.CreationDate) : 'Unknown', isDate: true, originalDate: (_e = markup.Topic) === null || _e === void 0 ? void 0 : _e.CreationDate },
            { label: 'Creation Author', value: ((_f = markup.Topic) === null || _f === void 0 ? void 0 : _f.CreationAuthor) || 'Unknown', isDate: false, originalDate: null }
        ];
        // Add optional details if they exist
        if ((_g = markup.Topic) === null || _g === void 0 ? void 0 : _g.ModifiedDate) {
            details.push({ label: 'Modified Date', value: (0, dateFormatter_1.formatDateTime)(markup.Topic.ModifiedDate), isDate: true, originalDate: markup.Topic.ModifiedDate });
        }
        if ((_h = markup.Topic) === null || _h === void 0 ? void 0 : _h.ModifiedAuthor) {
            details.push({ label: 'Modified Author', value: markup.Topic.ModifiedAuthor, isDate: false, originalDate: null });
        }
        if ((_j = markup.Topic) === null || _j === void 0 ? void 0 : _j.AssignedTo) {
            details.push({ label: 'Assigned To', value: markup.Topic.AssignedTo, isDate: false, originalDate: null });
        }
        // Create table rows
        details.forEach(detail => {
            const row = document.createElement('tr');
            const valueClass = detail.isDate ? 'detail-value detail-time' : 'detail-value';
            const titleAttribute = detail.isDate && detail.originalDate ? ` title="${(0, relativeTime_1.getRelativeTime)(detail.originalDate)}"` : '';
            row.innerHTML = `
				<td class="detail-label"><strong>${detail.label}:</strong></td>
				<td class="${valueClass}"${titleAttribute}>${detail.value}</td>
			`;
            table.appendChild(row);
        });
        detailsDiv.appendChild(table);
        topicDiv.appendChild(detailsDiv);
        // Add comments section only if there are comments
        if ((_l = (_k = markup.Topic) === null || _k === void 0 ? void 0 : _k.Comments) === null || _l === void 0 ? void 0 : _l.Comment) {
            const commentsElement = this.renderCommentsElement({ Comment: markup.Topic.Comments.Comment });
            topicDiv.appendChild(commentsElement);
        }
        // Add the images section
        const imagesElement = this.renderTopicImagesElement(topic.images);
        topicDiv.appendChild(imagesElement);
        return topicDiv;
    }
    renderTopicImagesElement(images) {
        console.log(`Rendering ${images.length} images:`, images);
        const container = document.createElement('div');
        container.className = 'images';
        if (!images || images.length === 0) {
            const noImages = document.createElement('p');
            noImages.textContent = 'No images available';
            container.appendChild(noImages);
            return container;
        }
        images.forEach((imageUrl, index) => {
            const imageContainer = document.createElement('div');
            imageContainer.className = 'image-container';
            imageContainer.style.margin = '10px 0';
            const label = document.createElement('p');
            label.textContent = `Image ${index + 1}:`;
            imageContainer.appendChild(label);
            const img = document.createElement('img');
            img.src = imageUrl;
            img.alt = `BCF Image ${index + 1}`;
            img.onload = () => console.log('Image loaded:', imageUrl);
            img.onerror = () => console.error('Failed to load image:', imageUrl);
            imageContainer.appendChild(img);
            container.appendChild(imageContainer);
        });
        return container;
    }
    renderCommentsElement(comments) {
        const container = document.createElement('div');
        container.className = 'comments-section';
        // Create comments header
        const header = document.createElement('h4');
        header.textContent = 'Comments';
        header.className = 'comments-header';
        container.appendChild(header);
        const commentArray = Array.isArray(comments.Comment) ? comments.Comment : [comments.Comment];
        // dumb hack because someone had the dumb idea to have the <Comment> inside a <Comment>...
        const validComments = commentArray.filter(comment => comment && comment.Comment && comment.Comment.trim() !== '');
        validComments.forEach((comment) => {
            const commentDiv = document.createElement('div');
            commentDiv.className = 'comment';
            const commentHeader = document.createElement('div');
            commentHeader.className = 'comment-header';
            const dateTitle = comment.Date ? ` title="${(0, relativeTime_1.getRelativeTime)(comment.Date)}"` : '';
            commentHeader.innerHTML = `
				<strong>${comment.Author || 'Unknown Author'}</strong>
				<span class="comment-date detail-time"${dateTitle}>${comment.Date ? (0, dateFormatter_1.formatDateTime)(comment.Date) : 'Unknown Date'}</span>
			`;
            const commentBody = document.createElement('div');
            commentBody.className = 'comment-body';
            commentBody.textContent = comment.Comment || '';
            commentDiv.appendChild(commentHeader);
            commentDiv.appendChild(commentBody);
            // Add modification info if available
            if (comment.ModifiedDate && comment.ModifiedAuthor) {
                const modificationInfo = document.createElement('div');
                modificationInfo.className = 'comment-modification';
                const modDateTitle = ` title="${(0, relativeTime_1.getRelativeTime)(comment.ModifiedDate)}"`;
                modificationInfo.innerHTML = `
					<small>Modified by <strong>${comment.ModifiedAuthor}</strong> on <span class="detail-time"${modDateTitle}>${(0, dateFormatter_1.formatDateTime)(comment.ModifiedDate)}</span></small>
				`;
                commentDiv.appendChild(modificationInfo);
            }
            container.appendChild(commentDiv);
        });
        return container;
    }
}
exports.default = BCFViewer;
